/* gpo-sync-unified.js
   Sincronizza coppie master/slave per:
   - Text/Textarea (nome)
   - Image Swatch (radio/btn con value)
   Pairing logica:
   - stessa pagina/prodotto: scopo nel form più vicino
   - stesso "tipo" (text vs swatch) rilevato dal contenuto dell'elemento
*/
(function(){
  // --- Rilevamento tipo elemento ------------------------
  function getKind(root){
    // Text-like?
    if (root.querySelector('input[type="text"], input[type="search"], input[type="tel"], input[type="email"], textarea')) {
      return 'text';
    }
    // Swatch-like (radio/checkbox o bottoni con data-value)
    if (root.querySelector('input[type="radio"], input[type="checkbox"], [data-value], [data-gpo-value]')) {
      return 'swatch';
    }
    return null;
  }

  // --- TEXT: copia valore e notifica GPO ----------------
  function bindText(masterRoot, slaveRoot){
    const master = masterRoot.querySelector('input[type="text"], input[type="search"], input[type="tel"], input[type="email"], textarea');
    const slave  = slaveRoot.querySelector('input[type="text"], input[type="search"], input[type="tel"], input[type="email"], textarea');
    if (!master || !slave) return;

    if (master.dataset.gpoBound) return;
    master.dataset.gpoBound = '1';

    const sync = () => {
      if (slave.value !== master.value) {
        slave.value = master.value;
        slave.dispatchEvent(new Event('input',  {bubbles:true}));
        slave.dispatchEvent(new Event('change', {bubbles:true}));
      }
    };

    ['input','change','keyup','paste','compositionend'].forEach(evt=>{
      master.addEventListener(evt, sync);
    });
    sync(); // inizializza (default value)
  }

  // --- SWATCH: replica selezione ------------------------
  function getSelectedSwatchValue(root){
    const checked = root.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
    if (checked && checked.value) return checked.value;

    // Fallback su item "attivo"
    const active = root.querySelector('[data-value].active, [data-gpo-value].active');
    if (active) return active.getAttribute('data-value') || active.getAttribute('data-gpo-value');

    // Ultimo fallback: un input con aria-checked true
    const aria = root.querySelector('[aria-checked="true"][data-value], [aria-checked="true"][data-gpo-value]');
    if (aria) return aria.getAttribute('data-value') || aria.getAttribute('data-gpo-value');

    return null;
  }

  function setSelectedSwatchValue(root, value){
    if (!value) return;

    // 1) prova con <input value="...">
    const input = root.querySelector(`input[value="${CSS.escape(value)}"]`);
    if (input) {
      if (!input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('input',  {bubbles:true}));
        input.dispatchEvent(new Event('change', {bubbles:true}));
      }
      return;
    }

    // 2) prova su bottoni/swatch con data-value
    const btn = root.querySelector(`[data-value="${CSS.escape(value)}"], [data-gpo-value="${CSS.escape(value)}"]`);
    if (btn) {
      btn.click(); // genera gli eventi UI che GPO intercetta
    }
  }

  function bindSwatch(masterRoot, slaveRoot){
    if (masterRoot.dataset.gpoBound) return;
    masterRoot.dataset.gpoBound = '1';

    const sync = () => {
      const val = getSelectedSwatchValue(masterRoot);
      setSelectedSwatchValue(slaveRoot, val);
    };

    masterRoot.addEventListener('change', sync, true);
    masterRoot.addEventListener('click',  sync, true);
    sync(); // inizializza (default)
  }

  // --- Pairing master/slave dello stesso TIPO -----------
  function bindPair(masterRoot){
    const kind = getKind(masterRoot);
    if (!kind) return;

    const scope = masterRoot.closest('form, .gpo-container, .product-form') || document;

    // Trova un "slave" nello stesso scope con lo stesso tipo
    const candidates = Array.from(scope.querySelectorAll('.gpo-sync-slave'))
      .filter(el => getKind(el) === kind && !el.dataset.gpoSlaveTaken);

    const slaveRoot = candidates[0];
    if (!slaveRoot) return;

    slaveRoot.dataset.gpoSlaveTaken = '1'; // evita doppio bind

    if (kind === 'text')  bindText(masterRoot,  slaveRoot);
    if (kind === 'swatch') bindSwatch(masterRoot, slaveRoot);
  }

  // --- Scanner iniziale + dinamico ----------------------
  function scan(){
    document.querySelectorAll('.gpo-sync-master').forEach(bindPair);
  }

  document.addEventListener('DOMContentLoaded', scan);
  setTimeout(scan, 600);
  setTimeout(scan, 1500);

  new MutationObserver(scan).observe(document.documentElement, {childList:true, subtree:true});
})();
